module.exports = __webpack_public_path__ + "static/media/pinInput.463e5a52.svg";